var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// - Import react components
import { firebaseAuth, db } from 'data/firestoreClient';
import { LoginUser, RegisterUserResult } from 'core/domain/authorize';
import { SocialError } from 'core/domain/common';
import { OAuthType } from 'core/domain/authorize/oauthType';
import moment from 'moment/moment';
import { injectable } from 'inversify';
/**
 * Firbase authorize service
 *
 * @export
 * @class AuthorizeService
 * @implements {IAuthorizeService}
 */
var AuthorizeService = /** @class */ (function () {
    function AuthorizeService() {
        var _this = this;
        /**
         * Logs out the user
         *
         * @returns {Promise<void>}
         * @memberof IAuthorizeService
         */
        this.logout = function () {
            return new Promise(function (resolve, reject) {
                firebaseAuth()
                    .signOut()
                    .then(function (result) {
                    resolve();
                })
                    .catch(function (error) {
                    reject(new SocialError(error.code, error.message));
                });
            });
        };
        /**
         * Update user password
         *
         * @returns {Promise<void>}
         * @memberof IAuthorizeService
         */
        this.updatePassword = function (newPassword) {
            return new Promise(function (resolve, reject) {
                var user = firebaseAuth().currentUser;
                if (user) {
                    user.updatePassword(newPassword).then(function () {
                        // Update successful.
                        resolve();
                    }).catch(function (error) {
                        // An error happened.
                        reject(new SocialError(error.code, error.message));
                    });
                }
            });
        };
        /**
         * On user authorization changed event
         *
         * @memberof IAuthorizeService
         */
        this.onAuthStateChanged = function (callBack) {
            firebaseAuth().onAuthStateChanged(function (user) {
                var isVerifide = false;
                if (user) {
                    if (user.emailVerified || user.providerData[0].providerId.trim() !== 'password') {
                        isVerifide = true;
                    }
                    else {
                        isVerifide = false;
                    }
                }
                callBack(isVerifide, user);
            });
        };
        /**
         * Reset user password
         *
         * @memberof AuthorizeService
         */
        this.resetPassword = function (email) {
            return new Promise(function (resolve, reject) {
                var auth = firebaseAuth();
                auth.sendPasswordResetEmail(email).then(function () {
                    resolve();
                }).catch(function (error) {
                    // An error happened.
                    reject(new SocialError(error.code, error.message));
                });
            });
        };
        /**
         * Send verfication email to user email
         *
         * @memberof AuthorizeService
         */
        this.sendEmailVerification = function () {
            return new Promise(function (resolve, reject) {
                var auth = firebaseAuth();
                var user = auth.currentUser;
                if (user) {
                    user.sendEmailVerification().then(function () {
                        resolve();
                    }).catch(function (error) {
                        // An error happened.
                        reject(new SocialError(error.code, error.message));
                    });
                }
                else {
                    reject(new SocialError('authorizeService/nullException', 'User was null!'));
                }
            });
        };
        this.loginWithOAuth = function (type) {
            return new Promise(function (resolve, reject) {
                var provider;
                switch (type) {
                    case OAuthType.GITHUB:
                        provider = new firebaseAuth.GithubAuthProvider();
                        break;
                    case OAuthType.FACEBOOK:
                        provider = new firebaseAuth.FacebookAuthProvider();
                        break;
                    case OAuthType.GOOGLE:
                        provider = new firebaseAuth.GoogleAuthProvider();
                        break;
                    default:
                        throw new SocialError('authorizeService/loginWithOAuth', 'None of OAuth type is matched!');
                }
                firebaseAuth().signInWithPopup(provider).then(function (result) {
                    // The signed-in user info.
                    var user = result.user;
                    var credential = result.credential;
                    var uid = user.uid, displayName = user.displayName, email = user.email, photoURL = user.photoURL;
                    var providerId = credential.providerId;
                    _this.storeUserProviderData(uid, email, displayName, photoURL, providerId, 'No Access token provided!'); // firstTime = true
                    // this.storeUserInformation(uid,email,displayName,photoURL).then(resolve)
                    resolve(new LoginUser(user.uid, true, providerId, displayName, email, photoURL));
                }).catch(function (error) {
                    // Handle Errors here.
                    var errorCode = error.code;
                    var errorMessage = error.message;
                    // The email of the user's account used.
                    var email = error.email;
                    // The firebase.auth.AuthCredential type that was used.
                    var credential = error.credential;
                });
            });
        };
        /**
         * Store user information
         *
         * @private
         * @memberof AuthorizeService
         */
        this.storeUserInformation = function (userId, email, fullName, avatar, firstTime) {
            return new Promise(function (resolve, reject) {
                db.doc("userInfo/" + userId).set({
                    id: userId,
                    state: 'active',
                    avatar: avatar,
                    fullName: fullName,
                    creationDate: moment().unix(),
                    email: email,
                    firstTime: firstTime
                    // added prop1 Any fields you want to ad to firebase when the user is created go here!!
                })
                    .then(function () {
                    resolve(new RegisterUserResult(userId));
                })
                    .catch(function (error) { return reject(new SocialError(error.name, 'firestore/storeUserInformation : ' + error.message)); });
            });
        };
        /**
         * Store user provider information
         *
         * @private
         * @memberof AuthorizeService
         */
        this.storeUserProviderData = function (userId, email, fullName, avatar, providerId, accessToken) {
            return new Promise(function (resolve, reject) {
                db.doc("userProviderInfo/" + userId)
                    .set({
                    userId: userId,
                    email: email,
                    fullName: fullName,
                    avatar: avatar,
                    providerId: providerId,
                    accessToken: accessToken
                })
                    .then(function () {
                    resolve(new RegisterUserResult(userId));
                })
                    .catch(function (error) { return reject(new SocialError(error.name, error.message)); });
            });
        };
    }
    /**
     * Login the user
     */
    AuthorizeService.prototype.login = function (email, password) {
        return __awaiter(this, void 0, void 0, function () {
            var result, user, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, firebaseAuth()
                                .signInWithEmailAndPassword(email, password)];
                    case 1:
                        result = _a.sent();
                        user = result.user;
                        if (user) {
                            return [2 /*return*/, new LoginUser(user.uid, user.emailVerified)];
                        }
                        else {
                            throw new SocialError('AuthorizeService/login', 'User object is empty!');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        throw new SocialError(error_1.code, error_1.message);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Register a user
     */
    AuthorizeService.prototype.registerUser = function (registerUser) {
        return __awaiter(this, void 0, void 0, function () {
            var result, user, uid, email, registerResult, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, firebaseAuth()
                                .createUserWithEmailAndPassword(registerUser.email, registerUser.password)];
                    case 1:
                        result = _a.sent();
                        user = result.user;
                        if (!user) return [3 /*break*/, 3];
                        uid = user.uid, email = user.email;
                        return [4 /*yield*/, this.storeUserInformation(uid, email, registerUser.fullName, '', true)];
                    case 2:
                        registerResult = _a.sent();
                        return [2 /*return*/, registerResult];
                    case 3: throw new SocialError('AuthorizeService/login', 'User object is empty!');
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error_2 = _a.sent();
                        throw new SocialError(error_2.code, error_2.message);
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AuthorizeService = __decorate([
        injectable()
    ], AuthorizeService);
    return AuthorizeService;
}());
export { AuthorizeService };



//////////////////
// WEBPACK FOOTER
// ./src/data/firestoreClient/services/authorize/AuthorizeService.ts
// module id = 312
// module chunks = 50